<template>
  <ProductSeriesPage
    :title="title"
    :subtitle="subtitle"
    :hero-image="heroImage"
    :items="items"
  />
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import ProductSeriesPage from '@/components/ProductSeriesPage.vue'
import seriesProductImages from './seriesProductImages'

const { t, tm, locale } = useI18n()
const heroImage = require('@/assets/images/pixso-automotive-products/hero-ins.png')
const isEnglish = computed(() => locale.value === 'en')

const itemImages = [
  seriesProductImages.inm13s1,
  seriesProductImages.inm14
]

const title = computed(() => t('AutomotiveIndex.series.items.ins.title'))
const subtitle = computed(() => (isEnglish.value ? '' : t('AutomotiveIndex.series.items.ins.subtitle')))

const items = computed(() => {
  const seriesItems = tm('INM11.series.items') || []
  const itemLinks = ['/product/automotive/ins/inm13-s1', '/product/automotive/ins/inm14']

  return seriesItems.map((item, index) => ({
    title: item.title,
    description: item.description,
    image: itemImages[index],
    to: itemLinks[index]
  }))
})
</script>
